import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';
import { useEffect, useState } from 'react';
import { PqrResponseMedium } from '../../../../../../shared/types/modules/pqr';
import { PqrWebResponseMediumProps } from './props';
import { asyncGetParams } from '../../../../../../services/param.service';

export const usePqrWebResponseMedium = ({
    data,
    onChangeData,
    onChangeFormik,
}: PqrWebResponseMediumProps) => {
    const [responseMediums, setResponseMediums] = useState<ISelect[]>([]);

    const onSubmit = (data: PqrResponseMedium) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        asyncGetParams(ParamEnum.PQR_RESPONSE_MEDIUM).then((items) => {
            setResponseMediums(items);
            const filterEmail =
                items?.filter(
                    (item) =>
                        item.code === `${ParamEnum.PQR_RESPONSE_MEDIUM}_CE`
                )[0] || undefined;
            formik?.setFieldValue(
                'responseMedium',
                filterEmail?.id || data?.responseMedium
            );
        });
    }, []);

    return {
        formik,
        responseMediums,
    };
};
